import { Component } from '@angular/core'
import { BaseCellComponent } from './base-cell.component'
import { LabeledDisplayComponent } from '../../labeled-display/labeled-display.component'

export type EntityCellComponentProps<D> = Readonly<{
  label?: (data: D) => string;
  value: (data: D) => string;
}>

@Component({
  selector: 'entity-cell',
  imports: [LabeledDisplayComponent],
  styles: `
    span[app-labeled-display]::ng-deep {
      margin-top: 0;
    }
  `,
  template: `
    @if(params.data) {
      <span app-labeled-display [label]="params.label?.(params.data)" [value]="params.value(params.data)"></span>
    }
  `,
})
export class EntityCellComponent<
  DATA,
  FIELD extends keyof DATA,
> extends BaseCellComponent<
    DATA,
    EntityCellComponentProps<DATA>,
    FIELD
  > {}
